<template>
  <div class="container">
    <BFormInput
      ref="field1"
      maxlength="1"
      :value="authCodes.code1"
      type="number"
      autocomplete="one-time-code"
      pattern="\d*"
      class="code-input"
      @input="onInput($event, 1)"
      @keyup.backspace="onKeyupBackspace($event, 1)"
    />
    <BFormInput
      ref="field2"
      maxlength="1"
      :value="authCodes.code2"
      type="number"
      autocomplete="one-time-code"
      pattern="\d*"
      class="code-input"
      @input="onInput($event, 2)"
      @keyup.backspace="onKeyupBackspace($event, 2)"
    />
    <BFormInput
      ref="field3"
      maxlength="1"
      :value="authCodes.code3"
      type="number"
      autocomplete="one-time-code"
      pattern="\d*"
      class="code-input"
      @input="onInput($event, 3)"
      @keyup.backspace="onKeyupBackspace($event, 3)"
    />
    <BFormInput
      ref="field4"
      maxlength="1"
      :value="authCodes.code4"
      type="number"
      autocomplete="one-time-code"
      pattern="\d*"
      class="code-input"
      @input="onInput($event, 4)"
      @keyup.backspace="onKeyupBackspace($event, 4)"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from "vue-facing-decorator";

type AuthCodesType = {
  code1: string;
  code2: string;
  code3: string;
  code4: string;
};

@Component
export default class SmsAuthCodes extends Vue {
  @Prop({
    type: String,
    default: null
  })
  value!: string | null;
  authCodes: AuthCodesType = {
    code1: "",
    code2: "",
    code3: "",
    code4: ""
  };

  get integratedSmsCode() {
    const arr = Object.values(this.authCodes);
    return arr.reduce((acc, currentVal) => acc + currentVal);
  }

  mounted() {
    if (this.$refs.field1) (this.$refs.field1 as HTMLElement).focus();
  }

  @Watch("value")
  onChangeValue() {
    if (this.value) return;
    this.resetAuthCodesValue();
  }

  @Watch("integratedSmsCode")
  onChangeIntegratedSmsCode() {
    this.$emit("input", this.integratedSmsCode);
  }

  onInput(v: string, index: number) {
    if (!v) return;
    // 認証コード4桁をコピペで入力した場合
    if (v.length === 4) {
      this.copyToEachInput(v);
    } else {
      this.authCodes[`code${index}` as keyof typeof this.authCodes] = v;
    }

    if (v.length === 4 || index === 4) {
      const refs = this.$refs.field1 as HTMLElement;
      refs.focus();
      return;
    }
    const nextIndex = index + 1;
    const ref = this.$refs[`field${nextIndex}`] as HTMLElement;
    ref.focus();
  }

  onKeyupBackspace(v: KeyboardEvent, index: number) {
    if (!v.key || index === 1) return;
    const prevIndex = index - 1;
    const ref = this.$refs[`field${prevIndex}`] as HTMLElement;
    ref.focus();
    this.authCodes[`code${prevIndex}` as keyof typeof this.authCodes] = "";
  }

  resetAuthCodesValue() {
    this.authCodes = Object.fromEntries(
      Object.entries(this.authCodes).map(([key]) => {
        return [key, ""];
      })
    ) as AuthCodesType;
  }

  copyToEachInput(code: string) {
    this.authCodes = Object.fromEntries(
      Object.entries(this.authCodes).map(([key], index) => {
        const splittedCode = code.substr(index, 1);
        return [key, splittedCode];
      })
    ) as AuthCodesType;
  }
}
</script>

<style lang="scss" scoped>
.code-input {
  width: 70px;
  height: 84px;
  font-size: 40px;
  color: #000;
  text-align: center;
  background-color: #e5e5e5;
  border-radius: 10px;
}

.container {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 340px;
}
</style>
